import { PortalConfigurationApi } from "@asd/customer-portal-api";

import { axiosInstance } from "./AxiosInstance";

export class ConfigurationService {
  static instance: ConfigurationService;
  private configurationApi;

  constructor() {
    if (ConfigurationService.instance) {
      return ConfigurationService.instance;
    }

    this.configurationApi = new PortalConfigurationApi(undefined, undefined, axiosInstance);

    ConfigurationService.instance = this;
  }

  public async getSystemConfig(options: object = {}) {
    if (!this.configurationApi) {
      throw new Error("configurationApi is not initialized");
    }

    try {
      const response = await this.configurationApi.getSystemConfig(options);
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new ConfigurationService();
